<script setup>
import { onBeforeMount, defineProps, computed, ref, onMounted } from "vue";
import Modal from "@/components/elements/Modal.vue";
import CloseIcon from "@/assets/svg/CloseIcon.vue";
import GetStarted from "../elements/GetStarted.vue";
import { useRoute, useRouter } from "vue-router";
import { triggerTrackEvents } from "../../mixins/events_handler";

const route = useRoute();
const queryParams = route.query;
const router = useRouter();

const props = defineProps({
  element: {
    type: Object,
  },
  currentStudio: {
    type: Object,
  }
});

const isMobile = ref(false);
const isDesktop = ref(false);
const checkIsMobile = () => {
  let width =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth;
  isMobile.value = width < 640 ? true : false;
  isDesktop.value = width > 641 ? true : false;
};

  
onBeforeMount(() => {
  window.addEventListener("resize", checkIsMobile);
});
onMounted(() => {
  checkIsMobile();
});


  const isModalOptionfirstclass = ref(false);
    const showModalOptionfirstclass = () => {
        triggerTrackEvents('Header', 'Get Intro Offer', 'head_get_offers');
        isModalOptionfirstclass.value = true;
    };
    const closeModalOptionfirstclass = () => {
        isModalOptionfirstclass.value = false;
    };
</script>
<template>
    <div id="our_mission" class="module-container module-container-our_mission">
        <div class="container">
            <div class="row">
              
                <section class="section-container col-70-lg">
                                     
                    <div class="element-contaier">
                        <h2 class="element-text text-align-left font-size-88 font-size-mobile-60">What to Expect at Your First Class</h2>
                    </div>
                    <div class="element-contaier">
                        <p class="element-text text-align-left font-size-20">
                            <span>
                             Getting ready for your first I Love Kickboxing class? We can't wait to meet you! Here are a few beginner tips to help you show up ready to crush your 45-minute workout.
                            </span>
                            <ul class="list-bullet">
                                <li>
                                    As a First-Time Fighter, please arrive 15-20 minutes before your first group fitness class so we can help you get ready. 
                                </li>
                                <li>
                                    Like martial arts studios, we train barefoot and do not wear shoes in class.
                                </li>
                                <li>
                                   You will need hand wraps and boxing gloves; we'll help you secure the right gear before class.
                                   </li>
                                <li>
                                    Each workout begins with a warm-up, followed by kickboxing bag work, and finishes with core exercises and a cooldown.
                                </li>
                                <li>
                                    In class, you’ll learn real kickboxing techniques—exciting, empowering skills that not only keep you engaged but also help you reach your fitness goals.
                                </li>
                                <li>
                                    Your ILKB Coach is with you every step of the way, so if you have any questions during class, just give them a wave!
                                </li>
                                <li>
                                    We encourage you to take each exercise at your own pace, and if you need any modifications, your Coach will be happy to assist. 
                                </li>
                            </ul>
                        </p>
                    </div>
                    <div class="element-contaier">
                     <button type="button"  class="nav-link btn btn-primary"
                        @click="showModalOptionfirstclass" 
                        >   Try A Class</button>
                    </div>
                </section>
                 <section class="section-container col-30-lg">
<img src="https://res.cloudinary.com/ilovekickboxing/image/upload/v1752676239/Day_One_-_Wrap_Hands_1_z85qc5.png" style="max-width: 350px; " />

                 </section>
<Modal modalLarge="true" v-if="isModalOptionfirstclass">
        <template #body>
            <span class="modal-close" @click="closeModalOptionfirstclass">
                <CloseIcon />
            </span>
            <GetStarted :redirectedToCheckout="true" :redirectedToStudio="false" :currentStudio="currentStudio" />
        </template>
    </Modal>
            </div>
        </div>
    </div>
</template>